module.exports = __webpack_public_path__ + "img/hk_room_floorplan_14_en.7fd45694.png";